import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  alpha
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

// Icons
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: theme.shape.borderRadius,
    minWidth: 180,
    boxShadow: theme.shadows[3],
    padding: theme.spacing(0.5, 0),
    backgroundColor: theme.palette.mode === 'dark'
      ? theme.palette.grey[900]
      : theme.palette.background.paper
  }
}));

const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'danger'
})(({ theme, danger }) => ({
  minHeight: 42,
  padding: theme.spacing(0.5, 2),
  margin: theme.spacing(0.25, 0.5),
  borderRadius: theme.shape.borderRadius / 2,
  transition: 'all 0.2s',
  '&:hover': {
    backgroundColor: danger
      ? alpha(theme.palette.error.main, 0.1)
      : theme.palette.action.hover
  },
  '& .MuiListItemIcon-root': {
    minWidth: 36,
    color: danger ? theme.palette.error.main : 'inherit'
  },
  '& .MuiListItemText-primary': {
    fontSize: '0.85rem',
    fontWeight: danger ? 500 : 400,
    color: danger ? theme.palette.error.main : theme.palette.text.primary
  }
}));

const ProjectContextMenu = ({
  anchorEl,
  onClose,
  onDeleteProject,
  onMoveUp,
  onMoveDown,
  canMoveUp,
  canMoveDown,
}) => {
  const { t } = useTranslation();

  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      {/* Move Up option */}
      <StyledMenuItem
        onClick={onMoveUp}
        disabled={!canMoveUp}
        sx={{ opacity: canMoveUp ? 1 : 0.5 }}
      >
        <ListItemIcon>
          <ArrowUpwardIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('projects.moveUp')} />
      </StyledMenuItem>

      {/* Move Down option */}
      <StyledMenuItem
        onClick={onMoveDown}
        disabled={!canMoveDown}
        sx={{ opacity: canMoveDown ? 1 : 0.5 }}
      >
        <ListItemIcon>
          <ArrowDownwardIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('projects.moveDown')} />
      </StyledMenuItem>

      <Divider sx={{ my: 0.5 }} />

      {/* Delete option */}
      <StyledMenuItem onClick={onDeleteProject} danger>
        <ListItemIcon>
          <DeleteIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary={t('projects.delete.menu')} />
      </StyledMenuItem>
    </StyledMenu>
  );
};

export default ProjectContextMenu;